module.exports = __webpack_public_path__ + "media/images/usaid-logo-119cbf7579c78a632a23adacb6ba948d.png";